import { FitnessLevel } from 'constants/user';

import FitnessLvl1 from 'assets/img/fitnessLvl1.svg';
import FitnessLvl2 from 'assets/img/fitnessLvl2.svg';
import FitnessLvl3 from 'assets/img/fitnessLvl3.svg';

const FITNESS_LEVEL_CARDS = [
    {
        title: 'basics.user.fitnessLevel.beginner',
        description: 'basics.user.fitnessLevel.description.beginner',
        Icon: FitnessLvl1,
        id: FitnessLevel.Beginner,
    },
    {
        title: 'basics.user.fitnessLevel.intermediate',
        description: 'basics.user.fitnessLevel.description.intermediate',
        Icon: FitnessLvl2,
        id: FitnessLevel.Intermediate,
    },
    {
        title: 'basics.user.fitnessLevel.advanced',
        description: 'basics.user.fitnessLevel.description.advanced',
        Icon: FitnessLvl3,
        id: FitnessLevel.Advanced,
    },
];

export { FITNESS_LEVEL_CARDS };
